import React from 'react'
import { notification } from 'antd'
import { listBatchesV4 } from '../../../services/api/3dApi'

const REGEX_BATCH_NAME = /^\w+-\d/
const ALLOWED_STATUS = ['transferred', 'wait_to_sew', 'sewing']

export const handleBatchScanSubmit = async ({
    valueInput,
    listBatch,
    setListBatch,
    setErrorInput,
    maxLimit,
}) => {
    const batchNames = Array.from(new Set(
        valueInput.split(/[,\s]+/).map(x => x.trim()).filter(Boolean)
    ))

    if (!batchNames.length) {
        setErrorInput('Mã lô sai định dạng.')
        return
    }

    const invalidFormat = batchNames.filter(name => !REGEX_BATCH_NAME.test(name))
    const validNames = batchNames.filter(name => REGEX_BATCH_NAME.test(name))

    if (!validNames.length) {
        setErrorInput('Mã lô sai định dạng.')
        return
    }

    const { data } = await listBatchesV4({
        name: { $in: validNames },
        limit: 100,
    })
    const { data: res } = Object.assign({}, data)
    const { batches = [] } = res

    const foundNames = batches.map(b => b.name)
    const notFound = validNames.filter(n => !foundNames.includes(n))
    const validBatches = batches.filter(b => ALLOWED_STATUS.includes(b.status))
    const invalidStatus = batches.filter(b => !ALLOWED_STATUS.includes(b.status))

    const merged = [...new Map([...listBatch, ...validBatches].map(b => [b._id, b])).values()]
    const overLimit = maxLimit != null && merged.length > maxLimit

    if (!overLimit && validBatches.length) {
        setListBatch(merged)
    }

    const errors = []
    if (invalidFormat.length)
        errors.push(`Sai định dạng: ${invalidFormat.join(', ')}`)
    if (notFound.length)
        errors.push(`Không tồn tại: ${notFound.join(', ')}`)
    if (invalidStatus.length)
        errors.push(`Trạng thái không hợp lệ: ${invalidStatus.map(b => `${b.name} (${b.status})`).join(', ')}`)
    if (overLimit)
        errors.push(`Vượt quá ${maxLimit} lô tối đa — không thêm lô nào.`)

    if (errors.length) {
        notification.error({
            message: 'Một số lô không hợp lệ',
            description: (
                <div>
                    {errors.map((err, i) => (
                        <div key={i}>• {err}</div>
                    ))}
                </div>
            ),
            placement: 'topRight',
            duration: 4.5,
        })
    }
}
